import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { PenaltyService } from '@service/syndic/penalty.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { PenaltyAddComponent } from '../penalty-add/penalty-add.component';

@Component({
  selector: 'app-penalty-list',
  templateUrl: './penalty-list.component.html',
  styleUrls: ['./penalty-list.component.scss']
})
export class PenaltyListComponent implements OnInit {
  @Input() penalties: any[] = [];
  @Input() trusteeUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private penaltyService: PenaltyService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'PENALTY_ADD' || data.action === 'PENALTY_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.trusteeUuid) {
      this.penaltyService.getList(this.trusteeUuid).subscribe((res: any) => {
        this.penalties = res || [];
      });
    }
  }

  addPenalty(): void {
    this.penaltyService.edit = false;
    this.penaltyService.setPenalty(null);
    this.modal(PenaltyAddComponent, 'modal-basic-title', 'lg');
  }

  editPenalty(row: any): void {
    this.penaltyService.edit = true;
    this.penaltyService.setPenalty(row);
    this.modal(PenaltyAddComponent, 'modal-basic-title', 'lg');
  }

  deletePenalty(item: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.penaltyService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  modal(component: any, type: string, size: string): void {
    const modalRef = this.modalService.open(component, {
      ariaLabelledBy: type, size: size, centered: true, backdrop: 'static'
    });
    modalRef.result.then((result) => {}, (reason) => {});
  }
}
